// extracted by mini-css-extract-plugin
export default {"Container":"style_Container__tP0mf","section-1":"style_section-1__4ICo5","content":"style_content__ri8ud","section-2":"style_section-2__XoJuu","section":"style_section__UYUUS"};